import { useSessionContext } from 'src/contexts';
import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';

const CompanyContextProvider: React.FC = props => {
  const [session, setSession] = useSessionContext();

  const { loading } = useGetCurrentCompany({
    onSuccess: ({ getCurrentCompany: { _id: currentCompanyId } }) => {
      setSession({ ...session, currentCompanyId });
    },
  });

  return <>{loading ? null : props.children}</>;
};

export default CompanyContextProvider;
